import * as diacritics from "diacritics"
import { DeliveryProvider } from "../models/restaurant"

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

export const sanitizeString = (string: string) => {
  return diacritics.remove(string.toLowerCase().replace(/\s/g, ""))
}

export const isBuzzRiders = (provider: DeliveryProvider | null) => {
  const buzzBrands = ["ritta", "otto", "jagger"] // Add "localhost" to the list if you want to test locally
  let isBuzz = false
  if (typeof window !== "undefined") {
    const pathname = window.location.hostname
    isBuzz = buzzBrands.some((brand) => pathname.includes(brand))
  }

  return provider === "rider" && isBuzz
}

export const setHTMLTagLang = (lang: string) => {
  document.documentElement.setAttribute("lang", lang)
}
